import { useState, useCallback } from 'react';

const ALLOWED_INDEXES = {
  'SP500': 'AAPL, MSFT, GOOGL, AMZN, TSLA, JPM, JNJ, V, PG, NVDA',
  'TSX': 'RY.TO, TD.TO, BNS.TO, ENB.TO, BMO.TO, CNR.TO, TRP.TO, SU.TO, BCE.TO, CNQ.TO',
  'CRYPTO': 'BTC-USD, SHIB-USD, ETH-USD, XVG-USD, XRD-USD'
};

const today = new Date().toISOString().split('T')[0];

const defaultParams = {
  index_name: 'SP500',
  custom_tickers: ALLOWED_INDEXES.SP500,
  start_date: '2023-01-01',
  end_date: today,
  drawdown_threshold: '0.2',
  initial_capital: '100000',
  n_top_performers: '5',
  holding_period_days: '30',
  risk_free_rate: '0.02',
};

const useFormState = (initialParams = defaultParams) => {
  const [params, setParams] = useState(initialParams);
  const [localError, setLocalError] = useState('');

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setParams(prev => ({ ...prev, [name]: value }));
    setLocalError('');
  }, []);

  const handleIndexChange = useCallback((indexName) => {
    setParams(prev => ({
      ...prev,
      index_name: indexName,
      custom_tickers: ALLOWED_INDEXES[indexName]
    }));
  }, []);

  const updateParam = useCallback((name, value) => {
    setParams(prev => ({ ...prev, [name]: value }));
  }, []);

  const updateParams = useCallback((updates) => {
    setParams(prev => ({ ...prev, ...updates }));
  }, []);

  const resetParams = useCallback(() => {
    setParams(defaultParams);
    setLocalError('');
  }, []);

  return {
    params,
    setParams,
    localError,
    setLocalError,
    handleInputChange,
    handleIndexChange,
    updateParam,
    updateParams,
    resetParams,
    ALLOWED_INDEXES,
  };
};

export default useFormState;